import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators, ValidatorFn, FormBuilder, AbstractControl } from '@angular/forms';

import { CookieService } from 'ngx-cookie-service';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from './../../../services/data/data.service';
//consultas
import { environment } from './../../../../environments/environment';
import { Apollo } from 'apollo-angular';
import { firstValueFrom, min, Subscription } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';

//servicios
import { getCuestionariosInfo } from './../../../services/Administrador/cuestionarios/query';
import { cuestionarios, CuestionariosService } from './../../../services/Administrador/cuestionarios/cuestionarios.service';
import { SemaphoresService } from './../../../services/Administrador/semaphores/semaphores.service';

import { messages } from '../../funciones/mensajes';

const surveyJson = {
  elements: [{
    name: "FirstName",
    title: "Enter your first name:",
    type: "option",
  }, {
    name: "LastName",
    title: "Enter your last name:",
    type: "text"
  }]
};


@Component({
  selector: 'app-alta-cuestionarios',
  templateUrl: './alta-cuestionarios.component.html',
  styleUrl: './alta-cuestionarios.component.css'
})
export class AltaCuestionariosComponent {

  /* Consultas */
  private headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  public cuestionarios = [];
  private edicion = null;
  private accion = '';
  public columnas = ['num', 'nombre', 'nombreCorto', 'semaforos', 'usuario', 'edicion'];

  public tab = true;
  public cue = false;
  public sem = false;

  semaforos = [{ codigo: 2, nombre: '2 colores' }, { codigo: 3, nombre: '3 colores' }, { codigo: 4, nombre: '4 colores' }, { codigo: 5, nombre: '5 colores' }]

  formCuestionario = new FormGroup({
    nombre: new FormControl(''),
    nombreCorto: new FormControl(''),
    usuarioCrea: new FormControl(''),
    allowMultipleResponses: new FormControl(false),

    numeroSemaforos: new FormControl('default'),
    sem1Val1id: new FormControl('default'),
    sem1Val1: new FormControl('default'),
    sem1Val2: new FormControl('default'),
    sem1Col: new FormControl('#000000'),
    sem2Val1: new FormControl('default'),
    sem2Val1id: new FormControl('default'),
    sem2Val2: new FormControl('default'),
    sem2Col: new FormControl('#000000'),
    sem3Val1: new FormControl('default'),
    sem3Val1id: new FormControl('default'),
    sem3Val2: new FormControl('default'),
    sem3Col: new FormControl('#000000'),
    sem4Val1: new FormControl('default'),
    sem4Val1id: new FormControl('default'),
    sem4Val2: new FormControl('default'),
    sem4Col: new FormControl('#000000'),
    sem5Val1: new FormControl('default'),
    sem5Val1id: new FormControl('default'),
    sem5Val2: new FormControl('default'),
    sem5Col: new FormControl('#000000'),
  });
  valoresDefault1 = {
    nombre: '',
    nombreCorto: '',
    usuarioCrea: '',
    allowMultipleResponses: false,
    numeroSemaforos: 'default',
    sem1Val1: 'default',
    sem1Val2: 'default',
    sem1Col: '#000000',
    sem2Val1: 'default',
    sem2Val2: 'default',
    sem2Col: '#000000',
    sem3Val1: 'default',
    sem3Val2: 'default',
    sem3Col: '#000000',
    sem4Val1: 'default',
    sem4Val2: 'default',
    sem4Col: '#000000',
    sem5Val1: 'default',
    sem5Val2: 'default',
    sem5Col: '#000000',
  }

  public array_semaforos = []
  public newsemaforoid = 0

  public prefix = '';
  public suffix = '';
  public miles = ',';
  public decimal = '.';
  public precicion = 1;
  public aling = '';

  constructor(
    private apollo: Apollo,
    public dataService: DataService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private cuestionarioService: CuestionariosService,
    private semaphoreService: SemaphoresService,
    private fb: FormBuilder
  ) {
    this.ListQuestionnaires()
  }
  /* Metodos de ordenamiento */
  private ordenarSem(array) {
    array.sort(function (a, b) {
      if (Number(a.min) > Number(b.min)) {
        return 1;
      }
      if (Number(a.min) < Number(b.min)) {
        return -1;
      }
      return 0;
    });
    return array;
  }
  /* Metodos de apertura de cuestionarios */
  public abrirFormSemaforos(cuest, accion) {
    this.tab = false;
    if (accion === 'edicionSem') {
      this.cue = false;
      this.sem = true;
    } else {
      this.cue = true;
      this.sem = false;
    }

    this.accion = accion;
    this.edicion = cuest;
    var i = 1;
    this.edicion.semaforos = this.ordenarSem(this.edicion.semaforos);
    
    this.formCuestionario.controls['nombre'].setValue(this.edicion.nombre);
    this.formCuestionario.controls['nombreCorto'].setValue(this.edicion.nombreCorto);
    this.formCuestionario.controls['usuarioCrea'].setValue(this.edicion.usuario);
    this.formCuestionario.controls['allowMultipleResponses'].setValue(this.edicion.allowMultipleResponses || false); 
    this.formCuestionario.controls['numeroSemaforos'].setValue(this.edicion.semaforos.length);

    for (const sem of this.edicion.semaforos) {
      this.formCuestionario.controls['sem' + i + 'Val1id'].setValue(sem.id);
      this.formCuestionario.controls['sem' + i + 'Val1id'].setValue(sem.id);
      this.formCuestionario.controls['sem' + i + 'Val1'].setValue(sem.min);
      this.formCuestionario.controls['sem' + i + 'Val2'].setValue(sem.max);
      this.formCuestionario.controls['sem' + i + 'Col'].setValue(sem.color);
      i++;
    }
  }
  public abrirFormFormulario(operacion) {
    this.edicion = null;
    this.tab = false;
    this.cue = true;
    this.sem = false;
    this.accion = operacion;
    this.formCuestionario.controls['sem1Val1'].setValue('0');
    this.formCuestionario.controls['usuarioCrea'].setValue(this.dataService.user);
  }
  public closeFoms() {
    this.tab = true;
    this.cue = false;
    this.sem = false;

    this.formCuestionario.reset(this.valoresDefault1);
  }
  public FormatearSemaphore(semaforos, questionaryId){
    var formasemaforo = []
    for(const sema of semaforos){
      formasemaforo.push({
        id: sema.id,
        questionaryId: questionaryId, 
        min: isNaN(sema.value_1)?'0':sema.value_1, 
        max: sema.value_2,
        color: sema.color
      })
    }
    return formasemaforo
  }

  public async ListQuestionnaires(){
    try{
      const res = await firstValueFrom(
        this.apollo.use(environment.api_cuestionarios).watchQuery<any>({
          query: getCuestionariosInfo,
          context: { headers: this.headers, },
          variables: {
            "args": {
              "relations": {
                "loadRelations": "BASIC"
              },
              "pagination": {
                "isUnlimit": true
              }
            }
          }
        }).valueChanges.source 
      );
      this.cuestionarios = [];
      
      if (res.data.questionnaires && Array.isArray(res.data.questionnaires)) {
        res.data.questionnaires.forEach((cuestionario) => {
          this.cuestionarios.push({
            id: cuestionario.id,
            nombre: cuestionario.name,
            nombreCorto: cuestionario.shortName,
            usuario: cuestionario.description,
            semaforos: this.FormatearSemaphore(cuestionario.semaphores, cuestionario.id),
            status: cuestionario.status,
            allowMultipleResponses: cuestionario.allowMultipleAnswers
          });
        });
      }
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  /* Cambio del número de semaforos */
  public numeroSemaforos() {
    const n = Number(this.formCuestionario.controls['numeroSemaforos'].value)
    for (var i = 1; i < n; i++) {
      this.ajusteSemaforos(i);
    }
  }
  /* seleccionar los colores */
  public numColors(pos) {
    if (Number(this.formCuestionario.controls['numeroSemaforos'].value) >= 2 && pos <= 2) {
      return false;
    } else if (Number(this.formCuestionario.controls['numeroSemaforos'].value) >= 3 && pos <= 3) {
      return false;
    } else if (Number(this.formCuestionario.controls['numeroSemaforos'].value) >= 4 && pos <= 4) {
      return false;
    } else if (Number(this.formCuestionario.controls['numeroSemaforos'].value) >= 5 && pos <= 5) {
      return false;
    }
    return true;
  }
  /* ajuste semaforos */
  public ajusteSemaforos(pos) {
    const numSel = Number(this.formCuestionario.controls['numeroSemaforos'].value);
    this.formCuestionario.controls['sem1Val1'].setValue('' + 0)
    switch (pos) {
      case 1:
        const v1 = Number(this.formCuestionario.controls['sem1Val2'].value);
        this.formCuestionario.controls['sem2Val1'].setValue('' + (v1 + 0.1));
        break;
      case 2:
        if (numSel > 2) {
          const v2 = Number(this.formCuestionario.controls['sem2Val2'].value);
          this.formCuestionario.controls['sem3Val1'].setValue('' + (v2 + 0.1));
        }
        break;
      case 3:
        if (numSel > 3) {
          const v3 = Number(this.formCuestionario.controls['sem3Val2'].value);
          this.formCuestionario.controls['sem4Val1'].setValue('' + (v3 + 0.1));
        }
        break;
      case 4:
        if (numSel > 4) {
          const v4 = Number(this.formCuestionario.controls['sem4Val2'].value);
          this.formCuestionario.controls['sem5Val1'].setValue('' + (v4 + 0.1));
        }
        break;
    }
  }
  /* Metodos de decisión de guardado */
  public puedeGuardar() {
    const nomL = this.formCuestionario.controls['nombre'].value;
    const nomC = this.formCuestionario.controls['nombreCorto'].value;
    const semN = this.formCuestionario.controls['numeroSemaforos'].value;
    const s1V1 = this.formCuestionario.controls['sem1Val1'].value;
    const s1V2 = this.formCuestionario.controls['sem1Val2'].value;
    const s2V1 = this.formCuestionario.controls['sem2Val1'].value;
    const s2V2 = this.formCuestionario.controls['sem2Val2'].value;
    const s3V1 = this.formCuestionario.controls['sem3Val1'].value;
    const s3V2 = this.formCuestionario.controls['sem3Val2'].value;
    const s4V1 = this.formCuestionario.controls['sem4Val1'].value;
    const s4V2 = this.formCuestionario.controls['sem4Val2'].value;
    const s5V1 = this.formCuestionario.controls['sem5Val1'].value;
    const s5V2 = this.formCuestionario.controls['sem5Val2'].value;

    const colorSelec = semN !== 'default' ? true : false;
    var valoresIng = false;
    if (colorSelec) {
      switch (Number(this.formCuestionario.controls['numeroSemaforos'].value)) {
        case 2:
          if (s1V1 !== '' && s1V2 !== '' && !this.montoCorrectoValidacion(1) &&
            s2V1 !== '' && s2V2 !== '' && !this.montoCorrectoValidacion(2)
          ) {
            valoresIng = true;
          }
          break;
        case 3:
          if (s1V1 !== '' && s1V2 !== '' && !this.montoCorrectoValidacion(1) &&
            s2V1 !== '' && s2V2 !== '' && !this.montoCorrectoValidacion(2) &&
            s3V1 !== '' && s3V2 !== '' && !this.montoCorrectoValidacion(3)
          ) {
            valoresIng = true;
          }
          break;
        case 4:
          if (s1V1 !== '' && s1V2 !== '' && !this.montoCorrectoValidacion(1) &&
            s2V1 !== '' && s2V2 !== '' && !this.montoCorrectoValidacion(2) &&
            s3V1 !== '' && s3V2 !== '' && !this.montoCorrectoValidacion(3) &&
            s4V1 !== '' && s4V2 !== '' && !this.montoCorrectoValidacion(4)
          ) {
            valoresIng = true;
          }
          break;
        case 5:
          if (s1V1 !== '' && s1V2 !== '' && !this.montoCorrectoValidacion(1) &&
            s2V1 !== '' && s2V2 !== '' && !this.montoCorrectoValidacion(2) &&
            s3V1 !== '' && s3V2 !== '' && !this.montoCorrectoValidacion(3) &&
            s4V1 !== '' && s4V2 !== '' && !this.montoCorrectoValidacion(4) &&
            s5V1 !== '' && s5V2 !== '' && !this.montoCorrectoValidacion(5)
          ) {
            valoresIng = true;
          }
          break;
      }
    }

    if (nomL !== '' && nomC !== '' && valoresIng) {
      return '';
    }

    return 'w3-disabled';
  }
  /* Validaciones */
  public montoCorrectoValidacion(pos) {

    var v1 = 0, v2 = 0;
    v1 = Number(this.formCuestionario.controls['sem'+pos+'Val1'].value);
    v2 = Number(this.formCuestionario.controls['sem' +pos+'Val2'].value);

    if (v1 >= v2) {
      return true; 
    }
    return false;

  }
  /* metodos de guardado */
  async AltaSemaforo(semaforo) {
    try {
      const data = await firstValueFrom(this.semaphoreService.postSemaphore(semaforo));
      semaforo['id'] = data['data'].id;
    } catch (error) {
      messages.errorMessageGraph(error.message);
    }
    // return semaforos
  }

  async AltaCuestionarioAsincrono(semaforos, cues) {
    try {
      const data = await firstValueFrom(this.cuestionarioService.postCuestionario(cues));
      this.array_semaforos = []
      for (const sema of semaforos) {
        var semaforo = {
          questionaryId: data['data'].id.toString(),
          min: sema.min.toString(),
          max: sema.max.toString(),
          color: sema.color
        }
        this.array_semaforos.push(semaforo);
        try {
          const status = await firstValueFrom(this.cuestionarioService.statusCuestionario(data['data'].id, 'draft'));
        } catch (error) {
          messages.errorMessageGraph(error.message);
        }
        this.AltaSemaforo(semaforo)

      }
      this.cuestionarios.push({
        id: data['data'].id,
        nombre: data['data'].name,
        nombreCorto: data['data'].shortName,
        usuario: data['data'].createdBy,
        semaforos: this.array_semaforos,
        allowMultipleResponses: data['data'].allowMultipleAnswers
      });
      messages.succesMessageGraph(this.translate.instant('admin.cuestionarios.succesN'));
      this.closeFoms();
    } catch (error) {
      messages.errorMessageGraph(error.message);
    }
  }
  /*  update */
  async UpdateSemaforo(semaforo) {
    try {
      const data = await firstValueFrom(this.semaphoreService.updateSemaphore(semaforo));
    } catch (error) {
      messages.errorMessageGraph(error.message);
    }
  }
  /* Delete */
  async DeleteSemaforo(id) {
    try {
      const data = await firstValueFrom(this.semaphoreService.deleteSemaphore(id));
    } catch (error) {
      messages.errorMessageGraph(error.message);
    }
  }

  async guardarDato() {
    const nomL = this.formCuestionario.controls['nombre'].value;
    const nomC = this.formCuestionario.controls['nombreCorto'].value;
    const user = this.formCuestionario.controls['usuarioCrea'].value;
    const allowMultiple = this.formCuestionario.controls['allowMultipleResponses'].value;
    const semN = Number(this.formCuestionario.controls['numeroSemaforos'].value);

    if (this.accion === 'nuevo') {
      var semaforos = [];
      for (var i = 1; i <= semN; i++) {
        semaforos.push({
          min: Number(this.formCuestionario.controls['sem' + i + 'Val1'].value),
          max: Number(this.formCuestionario.controls['sem' + i + 'Val2'].value),
          color: this.formCuestionario.controls['sem' + i + 'Col'].value,
        });
      }

      const cues = {
        id: (this.cuestionarios.length + 1),
        nombre: nomL,
        nombreCorto: nomC,
        usuario: user,
        weighting: 0,
        semaforos: semaforos,
        allowMultipleAnswers: allowMultiple
      };

      this.AltaCuestionarioAsincrono(semaforos, cues);

    } else {
      var auxSem = [];
      this.edicion.semaforos = this.ordenarSem(this.edicion.semaforos);

      for (var i = 1; i <= semN; i++) {
        auxSem.push({
          id: this.formCuestionario.controls['sem' + i + 'Val1id'].value,
          min: '' + this.formCuestionario.controls['sem' + i + 'Val1'].value,
          max: '' + this.formCuestionario.controls['sem' + i + 'Val2'].value,
          color: this.formCuestionario.controls['sem' + i + 'Col'].value,
          questionaryId: this.edicion.id
        });
      }

      for(const sem of auxSem){
        const ex = this.edicion.semaforos.find(e => Number(e.id) === Number(sem.id));
        if(ex){
          this.UpdateSemaforo(sem);
        }else{
          this.AltaSemaforo(sem);
        }
      }

      for(const sem of this.edicion.semaforos){
        const ex = auxSem.find(e => Number(e.id) === Number(sem.id));
        if(!ex){
          this.DeleteSemaforo(sem.id);
        }
      }

      this.edicion.semaforos = auxSem;

      if (this.accion === 'edicion') {
        this.edicion.nombre = this.formCuestionario.controls['nombre'].value;
        this.edicion.nombreCorto = this.formCuestionario.controls['nombreCorto'].value;
        this.edicion.usuario = this.formCuestionario.controls['usuarioCrea'].value;
        this.edicion.allowMultipleResponses = this.formCuestionario.controls['allowMultipleResponses'].value;

        try {
          const cues = await firstValueFrom(this.cuestionarioService.updateCuestionario(this.edicion));
          messages.succesMessageGraph(this.translate.instant('admin.cuestionarios.succesN'));
          this.closeFoms();
        } catch (err: any) {
          messages.errorMessageGraph(err.error.message);
        }
      } else {
        messages.succesMessageGraph(this.translate.instant('admin.cuestionarios.succesN'));
        this.closeFoms();
      }
    }

  }

  async eliminarCuestionario(item) {
    try {
      var aux = [];
      for (const cues of this.cuestionarios) {
        if (cues.id !== item.id) {
          aux.push(cues);
        } else {
          for (const sema of cues.semaforos) {
            this.DeleteSemaforo(sema.id)
          }
        }
      }
      const data = await firstValueFrom(this.cuestionarioService.deleteCuestionario(item.id));
      this.cuestionarios = aux;
      messages.succesMessageGraph(this.translate.instant('admin.cuestionarios.succesD'));
    } catch (error) {
      messages.errorMessageGraph(error.message);
    }
  }

}
